import React, { useEffect, useRef } from "react";

import { playSentenceAudio } from "./storyAudio";
import useAnchoredPopover, { elementAnchor } from "./useAnchoredPopover";

export default function StorySentencePanel({
  anchorTestId,
  canListen,
  hasNext,
  languageCode,
  languageIso,
  sentence,
  showExplain,
  onAddSentence,
  onClose,
  onExplain,
  onListen,
  onListenEnd,
  onListenStart,
  onNext
}) {
  const stopRef = useRef(() => {});
  const isResumingStoryRef = useRef(false);
  const panelRef = useRef(null);
  const style = useAnchoredPopover({ anchor: elementAnchor(anchorTestId), panelRef, onClose });

  const stopListening = () => {
    stopRef.current();
    stopRef.current = () => {};
    if (isResumingStoryRef.current) onListenEnd();
    isResumingStoryRef.current = false;
  };

  useEffect(() => stopListening, []);

  const listen = (rate) => {
    onListen();
    stopRef.current();
    isResumingStoryRef.current = isResumingStoryRef.current || onListenStart();
    const finishListening = () => {
      stopRef.current = () => {};
      if (isResumingStoryRef.current) onListenEnd();
      isResumingStoryRef.current = false;
    };
    stopRef.current = playSentenceAudio({
      sentence,
      rate,
      languageIso,
      languageCode,
      onEnded: finishListening,
      onError: finishListening
    });
  };

  return (
    <div aria-label="Sentence" className="story-sentence-popover" data-testid="story-sentence-panel" ref={panelRef} role="dialog" style={style}>
      {!!sentence.translation && <p className="story-sentence-popover-translation">{sentence.translation}</p>}
      <div className="story-sentence-popover-actions">
        {canListen && (
          <>
            <button aria-label="Listen to this sentence" className="story-sentence-tile" type="button" onClick={() => listen(1)}>
              <span className="fa fa-volume-up" />
              Listen
            </button>
            <button aria-label="Listen at half speed" className="story-sentence-tile" type="button" onClick={() => listen(0.5)}>
              <span className="fa fa-volume-down" />
              Listen at 0.5×
            </button>
          </>
        )}
        <button className="story-sentence-tile" type="button" onClick={onAddSentence}>
          <span className="fa fa-bookmark-o" />
          Add sentence
        </button>
        {showExplain && (
          <button className="story-sentence-tile" type="button" onClick={onExplain}>
            <span className="fa fa-lightbulb-o" />
            Explain
          </button>
        )}
      </div>
      <div className="story-sentence-popover-footer">
        <span>Esc to close</span>
        {hasNext && (
          <button className="story-sentence-popover-next" type="button" onClick={onNext}>
            Next sentence <span className="fa fa-arrow-right" />
          </button>
        )}
      </div>
    </div>
  );
}
